// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"867b0c8c","239":"e943a090","396":"e04ebda9","453":"73999408","455":"0f873a44","977":"94782c42"}[chunkId] + ".chunk.js";
};